const { mappingError } = require("@/utils/errorAlert/errorMapper");
const { checkNotEmpty } = require("@/utils/popup/common");
const { Error } = require("@/utils/popup/Error");
const { GA_ACTIONS, PRODUCT_TYPE } = require("@/utils/Constants.js");
export const ErrorAlertHandler = (error, head = 0, ctx) => {
    if (!checkNotEmpty(error) || !checkNotEmpty(head) || !checkNotEmpty(ctx))
        return;

    let code = "9999";
    if (error.response?.data?.code) {
        code = error.response.data.code;
    } else if (error.response?.status) {
        code = error.response.status;
    } else if (error.message?.startsWith("timeout")) {
        code = "5008";
    } else if (error.message?.toLowerCase().includes("network")) {
        code = "5010";
    }
    ErrorAlert(code, head, ctx);
};

export const ErrorAlert = (code, head = 0, ctx) => {
    
    if (!checkNotEmpty(code) || !checkNotEmpty(head) || !checkNotEmpty(ctx))
        return;
   
    const errorInfo = mappingError(code.toString(), head.toString());
    if (4007 == code.toString()) {
        ctx.$callback.gaTagging({
            action: GA_ACTIONS.VIEW,
            category: "DGLSelfApplyAppStatusDt_Failed",
            label: ""
        },
            [
                {
                    key: 38,
                    value: PRODUCT_TYPE.SMART_MONEY
                },
                {
                    key: 4,
                    value: "Status:".concat(ctx.userData.followupStatus.code == 'RESUBMIT' ? "RESUBMIT_DOCUMENT" : "PENDING_DOCUMENT_UPLOAD").concat(ctx.userData.expireDay == 1 ? ",Reminder:0":"")
                }
            ]);
    }
    if ("หมดเวลาทำรายการ" === errorInfo.title || "ไม่สามารถดำเนินการได้ในขณะนี้" === errorInfo.title  ) {
        ctx.$callback.gaTagging({
            action: GA_ACTIONS.ERROR,
            category: "DGLSelfApplyDocumentUpload"  ,
            label: errorInfo.title + "\\" + errorInfo.detail
        },
            [
                {
                    key: 38,
                    value: PRODUCT_TYPE.SMART_MONEY
                },
                {
                    key: 4,
                    value: "Status:".concat(ctx.userData.followupStatus.code == 'RESUBMIT' ? "RESUBMIT_DOCUMENT" : "PENDING_DOCUMENT_UPLOAD").concat(ctx.userData.expireDay == 1 ? ",Reminder:0":"")
                },
                {
                    key: 6,
                    value: "ER9999"
                },
                {
                    key: 9,
                    value: "Full Screen Error"
                }
            ]);
    }

    Error(
        {
            ...errorInfo,
            callback: () => {
                if ("ใบสมัครถูกยกเลิก" == errorInfo.title) {
                    ctx.$callback.gaTagging({
                        action: GA_ACTIONS.CLICK,
                        category: "DGLSelfApplyAppStatusDt_Failed",
                        label: "DGLSelfApplyAppStatusDt_Failed_Done"
                    },
                        [
                            {
                                key: 38,
                                value: PRODUCT_TYPE.SMART_MONEY
                            }

                        ]);
                }

                if ("หมดเวลาทำรายการ" === errorInfo.title || "ไม่สามารถดำเนินการได้ในขณะนี้" === errorInfo.title  ){
                    ctx.$callback.gaTagging({
                        action: GA_ACTIONS.CLICK,
                        category: "DGLSelfApplyDocumentUpload",
                        label: "DGLSelfApplyDocumentUpload_Confirm"
                    },
                        [
                            {
                                key: 38,
                                value: PRODUCT_TYPE.SMART_MONEY
                            }
                        ]);
                }



                switch (errorInfo.callbackAction) {
                    case "goToProductShelves":
                        try {
                            ctx.$callback.exitEntryPoint();
                        } catch (err) {
                            console.error(err);
                        }
                        break;
                    case "goToUpload":
                        try {
                            ctx.$callback.exitEntryPoint();
                        } catch (err) {
                            console.error(err);
                        }
                        break;
                    default:
                        break;
                }


              


            },
        },
        ctx.$swal
    );
};
